















































































import Vue from 'vue';
import * as api from '@/util/api';
import { Backup } from '@/openapi-types';
import { saveResponseAsFile, selectedFilter } from '@/util/helpers';
import DeleteBackupButton from '@/views/Settings/BackupAndRestore/DeleteBackupButton.vue';
import { Prop } from 'vue/types/options';
import RestoreBackupButton from '@/views/Settings/BackupAndRestore/RestoreBackupButton.vue';
import { encodePathParameter } from '@/util/api';
import { Permissions } from '@/global';
import { mapActions, mapState } from 'pinia';
import { useUser } from '@/store/modules/user';
import { useNotifications } from '@/store/modules/notifications';

export default Vue.extend({
  components: {
    DeleteBackupButton,
    RestoreBackupButton,
  },
  props: {
    filter: {
      type: String,
      default: '',
    },
    canBackup: {
      type: Boolean,
      default: false,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    backups: {
      type: Array as Prop<Backup[]>,
      required: true,
    },
  },
  computed: {
    ...mapState(useUser, ['hasPermission']),
    canRestore(): boolean {
      return this.hasPermission(Permissions.RESTORE_CONFIGURATION);
    },
  },
  methods: {
    ...mapActions(useNotifications, ['showError', 'showSuccess']),
    filtered(): Backup[] {
      return selectedFilter(this.backups, this.filter, 'created_at');
    },
    async downloadBackup(fileName: string) {
      api
        .get(`/backups/${encodePathParameter(fileName)}/download`, {
          responseType: 'blob',
        })
        .then((resp) => saveResponseAsFile(resp, fileName))
        .catch((error) => this.showError(error));
    },
    refreshData(): void {
      this.$emit('refresh-data');
    },
  },
});
